





import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class FitNumberBox extends Vue {
  // 可选值 normal regular
  @Prop({ default: 'default' }) type!: string;
}
